import React from "react";
import Button from "@components/Button";
import Icon from "@components/Icon";
import { iconRegistry } from "@components/Icon/iconRegistry";

type IconName = keyof typeof iconRegistry;

interface IntegrationConfigHeaderProps {
    title: string;
    iconName: IconName;
    iconColorClass?: string;
    backLabel?: string;
    onBack: () => void;
}

const IntegrationConfigHeader: React.FC<IntegrationConfigHeaderProps> = ({
    title,
    iconName,
    iconColorClass = "fill-deepblue",
    backLabel = "Back",
    onBack,
}) => (
    <div className="flex shrink-0 items-center justify-between border-b border-gray-20 px-4 py-2">
        <Button
            label={backLabel}
            type="button"
            variant="default"
            size="small"
            className="outline-btn !h-8 !min-h-8 !min-w-[79px] !rounded !border !border-gray-60 !bg-light-02 !px-3 !py-2 !text-[14px] !font-normal !leading-5 !normal-case !text-gray-60 hover:!bg-light-02 active:!bg-light-02"
            onClick={onBack}
        />
        <div className="flex h-12 items-center gap-2">
            <div className="flex size-11 items-center justify-center rounded-[5px] border border-dark-10 bg-white">
                <Icon
                    name={iconName}
                    width={24}
                    height={24}
                    className={iconColorClass}
                />
            </div>
            <p className="text-[20px] font-semibold leading-6 text-gray-100">{title}</p>
        </div>
    </div>
);

export default React.memo(IntegrationConfigHeader);
